import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import React, { useEffect, useState } from 'react';
import { Flex, Heading, Box, Text, Image } from 'rebass';
import TextField from 'app/form/formik/text/index';
import axios from 'axios';

import { useWindowSize } from 'react-use';
import store from 'store';
import Wrapper, { LoginSection } from './Wrapper';
import GiftBox from './assets/GiftBox.png';
import reviewerImage1 from './assets/reviewer-image1.png';
import reviewerImage2 from './assets/reviewer-image2.png';
import reviewerImage3 from './assets/reviewer-image3.png';
import useMatch from 'app/hooks/match';
import { useCreateNewAccount, useCreateNewV3Account, useLogin } from 'auth/hooks';
import { useHistory, useLocation, Link as RouterLink } from 'react-router-dom';
import { postMemberEvent, useGetMemberSWR } from 'members/api';
import useSendToGTM from 'utils/googleTagManager';
import { useMobileCheckHook } from 'story-media/hooks';
import { useCurrentMember } from 'members/hooks/index';
import { getAuthorizedHeaders, getJsonHeaders, getSWR, patch } from 'utils/api';
import Banner from 'app/payment/Banner';
import apiBase from 'utils/api-base';
import { IoMdClose, IoMdCheckmark, IoMdGift } from "react-icons/io";
import { getPrefixedEventName } from 'app/form/helper';
import Reviews from './Reviews';
import { useDispatch } from 'react-redux';
import { togglefirstTimeUserFlowVisible } from 'stories/actions';
import { getOrderId } from 'auth/member';
import Loading from 'app/loading';
import { getGiftCertificates } from 'account-dashboard/api';
import { isSelfClaimedGift } from 'members/helper';

const baseUrl = apiBase.replace('/v2', '');
let giftCertificateAdded = null;

const userReviews = [{
    title: 'The Best Keepsake in the Making!',
    review: '“Joining the beta, I knew this would be special – but it’s even better than I imagined! As a busy new mom, it’s been so easy to capture Ellie’s firsts: her smiles, giggles, and even her messy spaghetti night. Knowing this will become a beautiful keepsake book? Absolutely priceless.”',
    reviewer: {
        name: 'Emily, First-Time Mom',
        image: reviewerImage1
    }
},
{
    title: 'A Must-Have for Every Parent',
    review: 'During the holidays, we spent some quality family time together with our 17-year-old. One of the wonderful things we did was reread his Baby’s First Year scrapbook, which was diligently created by my wife 17 years ago. It was fantastic! Great, great memories, most of which would have been forgotten. I strongly recommend that everybody create a book like this. And wow — this would have been 100x easier with Baby’s First Year! And video too! Take it from an older parent — this should be a really easy decision!',
    reviewer: {
        name: 'Martin S.',
        image: reviewerImage2
    }
},
{
    title: 'The Perfect Start to Capturing Our Memories!',
    review: `"When my parents gave me a Baby's First Year gift certificate, I was thrilled! This made it so easy to start documenting Lily’s milestones and adding photos and videos. It’s already becoming a beautiful collection of moments, and I can’t wait to see how it all comes together in the book."`,
    reviewer: {
        name: 'Sarah, Proud Mama of Noah',
        image: reviewerImage3
    }
}]

const label = (text, isRequired) => <Text
    sx={{
        color: "codGrey",
        fontFeatureSettings: 'liga off, calt off',
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '20px', /* 142.857% */
        letterSpacing: '-0.084px',
    }}> {text} {isRequired && <span style={{ color: 'red' }}>*</span >}</Text >


export const FieldText = ({ name, type, disabled, placeholder, ...props }) => {
    return <Field
        component={TextField}
        name={name}
        type={type}
        showError
        placeholder={placeholder}
        m="auto"
        mb={[2, 4]}
        borderRadius='31px'
        sx={{
            width: 'inherit',
            borderColor: '#D9D9D9',
            cursor: disabled && 'not-allowed',
            borderRadius: '31px'
        }}
        {...props}
    />
}

const LoginSignUp = ({ onStepDown, onStepUp, isLogin = true, onLoginPress, redeemCode, setCurrentChildJournalId, setShowPaymentScreen, firePostMemberEvent }) => {
    const { params: query } = useMatch();
    const { push } = useHistory();
    const { pathname } = useLocation();
    const isFromMobile = useMobileCheckHook()

    const [showReviews, setShowReviews] = useState(!!isFromMobile && pathname.includes('/get-started'));
    const [showLogin, setShowLogin] = useState(isLogin)
    const [giftCertificate, setGiftCertificate] = useState(null);
    const [showGiftcard, setShowGiftcard] = useState(null);

    const [data, setData] = useState({});
    const [status, setStatus] = useState({ type: '', message: '' });
    const dispatch = useDispatch()

    const { width } = useWindowSize();
    const member = useCurrentMember()
    const createNewUser = useCreateNewAccount();

    const { revalidate } = useGetMemberSWR('me', {
        revalidateOnFocus: false,
        shouldRetryOnError: false,
    });

    let orderId = getOrderId()
    async function createNewUserRequest() {
        if (!orderId) {
            if (!store.get('auth_token'))
                await createNewUser();
            if (firePostMemberEvent) {
                if (isFromMobile && pathname.includes('/get-started')) {
                    firePostMemberEvent('testimonials')
                }
            }
        }
    }

    function goToOnboarding(firstJournal, giftCertificatelength = 0) {
        if (firstJournal) {
            let redirectURL = firstJournal?.attributes?.state !== "initialized" ?
                `/account/${firstJournal?.attributes?.state === 'unassigned' ? 'unassigned' : 'my-books'}`
                : `/child-journals/${firstJournal.id}`;
            push(redirectURL)
        }
        else
            push(giftCertificatelength ? '/account/gifts' : '/account/unassigned')
        // if (!orderId) {
        //     if (giftCertificateAdded)
        //         return push(`/babys-first-year/get-started?step=3&redeemCode=${giftCertificateAdded}`)

        //     return push('/babys-first-year/get-started?step=2')
        // }
    }

    async function getChildJournals() {
        const { data, status } = await getSWR(`/v3/child_journals`);
        const { data: giftCertificatesData } = await getGiftCertificates();

        if (status === 200) {
            const childJournals = data?.data
            const giftCertificates = giftCertificatesData?.initial?.data
            const giftedJournalIds = new Set(
                giftCertificates
                    .filter(gift => !isSelfClaimedGift(gift))
                    .map(({ relationships }) => relationships?.['child-journal']?.data?.id)
                    .filter(Boolean)
            );
            revalidate();

            if (childJournals?.length) {

                const validJournals = childJournals
                    .filter(({ id, attributes }) => {
                        const subjectName = attributes?.['subject-name']?.toLowerCase() || '';

                        return (
                            !subjectName.includes('tap for intro') &&
                            !subjectName.includes('sample child journal') &&
                            !giftedJournalIds.has(id)
                        );
                    })
                    .sort(
                        (a, b) =>
                            new Date(b.attributes?.['updated-at']) -
                            new Date(a.attributes?.['updated-at'])
                    );

                const firstJournal = validJournals.filter(
                    ({ attributes }) =>
                        attributes?.state === 'initialized'
                )[0];

                const hasFMBSubscription = validJournals.some(
                    ({ attributes }) =>
                        attributes?.['has-baby-year-books-subscription'] ||
                        attributes?.['has-watch-me-grow-subscription'] ||
                        attributes?.['free-trial'] ||
                        attributes?.paid
                );

                const unassignedJournal = validJournals.find(
                    ({ attributes }) => attributes?.state === 'unassigned'
                );

                const myBookJournal = validJournals.find(
                    ({ attributes }) =>
                        attributes?.state === 'initialized' ||
                        attributes?.state === 'assigned'
                );

                const latestJournal = validJournals.filter(
                    ({ attributes }) =>
                        attributes?.state === 'initialized'
                )[0];

                if (hasFMBSubscription && latestJournal) {
                    // Account Type 2 - FMB
                    if (latestJournal?.attributes?.state === 'initialized') {
                        if (setCurrentChildJournalId) {
                            setCurrentChildJournalId(latestJournal.attributes?.id);
                        }


                        if (onStepUp) {
                            onStepUp(latestJournal.attributes?.id);
                        } else {
                            goToOnboarding(latestJournal);
                        }
                    } else {

                        if (latestJournal?.attributes?.['story-count'] === 0) {
                            dispatch(togglefirstTimeUserFlowVisible(true));
                        }

                        push(`/child-journals/${latestJournal.id}`);
                    }
                } else {
                    // Account Type 1 - Purchase Allocation Only
                    let redirectURL;

                    if (unassignedJournal) {
                        // Case 1: Unallocated books
                        redirectURL = '/account/unassigned';
                    } else if (myBookJournal) {
                        // Case 2 & 4: My Books exists
                        redirectURL = '/account/my-books';
                    } else {
                        // Case 3: Gifts
                        redirectURL = '/account/gifts';
                    }


                    if (firstJournal?.attributes?.['story-count'] === 0) {
                        dispatch(togglefirstTimeUserFlowVisible(true));
                    }

                    push(redirectURL);
                }
            }
            else {
                goToOnboarding(undefined, giftCertificates.length)
            }
        }
    }

    useEffect(() => {
        if (member?.['has-username-password-identifier'])
            getChildJournals()
        else {
            createNewUserRequest()
        }
    }, [member?.['has-username-password-identifier']])

    useEffect(() => {
        if (pathname.includes('child_journal_share')) {
            setShowLogin(false)
            return
        }
        if (pathname !== '/')
            setShowLogin(isLogin)
    }, [isLogin, pathname])

    const login = useLogin();
    const createNewAccount = useCreateNewV3Account()
    const sendToGTM = useSendToGTM();

    // const onErrorHandle = () => {
    //     if (err.response.status === 400) {
    //         store.set(
    //             'buzzCodeError',
    //             err.response?.data?.errors[0]?.detail || 'Buzzcode has already been applied'
    //         );
    //     }
    //     if (err.response.status === 410) {
    //         store.set(
    //             'buzzCodeError',
    //             err.response?.data?.errors[0]?.detail || 'Buzzcode doesnot exist'
    //         );
    //     }
    // }
    const requestOptions = () => ({
        method: 'GET',
        headers: getAuthorizedHeaders(),
    });

    async function getCouponDetails(code = null) {
        setGiftCertificate(code)
        const resp = await fetch(`${baseUrl}/v3/commerce/gift_certificates/${code}`, requestOptions())
        const response = await resp.json();

        if (response?.data === null || response?.errors?.length > 0) {
            setStatus({ type: 'error', message: 'Your gift certificate has been used or is unrecognized', subTitle: <>Please double check your code and try again. If you're still experiencing problems, please <Text as="a" href="mailto:hello@babyyearbooks.com" target="_blank" sx={{ textDecorationLine: 'underline', cursor: 'pointer', fontWeight: 500 }} color="inherit">contact us</Text></> })
            return false
        }
        setStatus({ type: 'success', message: "Gift card applied successfully", subTitle: "You're all set to preserve and celebrate your little one's firsts" })
        return true
    }

    const onSubmit = async (values, { setFieldError, setSubmitting }) => {
        const { 'gift-certificate': giftCertificate } = values
        const newvalues = { ...values, ...query };
        if (query?.['private-code']) newvalues.promotion_code = query?.['private-code'];

        try {

            if (showLogin)
                await login(values);
            else
                await createNewAccount(values);

            const gtmObject = showLogin
                ? {
                    event: 'bfy.signin',
                    email: values.email,
                }
                : {
                    event: 'bfy.registered',
                    firstName: values['first_name'],
                    lastName: values['last_name'],
                    email: values.email,
                };
            const token = store.get('auth_token');

            const resp = await axios.get(`${baseUrl}/v3/me/`, {
                headers: {
                    ...getJsonHeaders(),
                    Authorization: `Token ${token}`
                },
            })

            if (resp.status === 200)
                gtmObject.User_Id = resp.data?.data?.attributes['tracking-identifier'];

            sendToGTM(gtmObject);

            if (!showLogin && !onStepUp)
                postMemberEvent(getPrefixedEventName('tell_us_about_baby', width < 600))
            if (giftCertificate)
                giftCertificateAdded = giftCertificate
            else
                giftCertificateAdded = null

            if (pathname === '/' || pathname.includes('index.html') || showLogin) {
                revalidate()
                // revalidateJournals()
                // push(redirectURL);
            }
            else {
                revalidate()
                onStepUp()
            }
        } catch (err) {
            const errors = [];
            if (err && err.response && err.response.data && JSON.parse(err.response.data).errors) {
                JSON.parse(err.response.data).errors.forEach((error) => {
                    if (error.detail && error.detail.includes('Invalid Password')) {
                        setFieldError('password', 'Invalid Password')
                    }
                    else if (error.detail && error.detail.includes('Account Exists')) {
                        setFieldError('email', 'An account with this email already exists')

                        errors.push('An account with this email already exists');
                    }
                    else if (error.detail && error.detail.includes('Account Not Found')) {
                        setFieldError('email', 'Account Not Found')

                        errors.push('An account with this email already exists');
                    }
                    else {
                        const parsedErrorDetails = JSON.parse(error.detail)
                        const { message } = parsedErrorDetails
                        setFieldError('password', message);
                    }
                });
            }
        }
        setSubmitting(false);
    }

    function setInitialValues() {
        if (showLogin)
            return {
                'gift-certificate': giftCertificate || '',
                email: '',
                password: '',
            }

        return {
            'gift-certificate': giftCertificate || '',
            'first_name': '',
            'last_name': '',
            email: '',
            password: '',
        }
    }

    function setShowValidationSchema() {
        if (showLogin)
            return Yup.object().shape({
                email: Yup.string().email().required(),
                password: Yup.string().min(6).required(),
            })

        return Yup.object().shape({
            'first_name': Yup.string().required(),
            'last_name': Yup.string().required(),
            email: Yup.string().email().required(),
            password: Yup.string().min(6).required(),
        })
    }

    function title() {
        if (showLogin) return "Login To Your Account"
        return 'Create Your Account'
    }

    function nextButtonText() {
        if (showLogin) return "Sign In"
        return "Sign Up"
    }

    const toggleLogin = onLoginPress ? onLoginPress : () => {
        if (pathname === '/' && showLogin && !onStepUp)
            postMemberEvent(getPrefixedEventName('create_account', width < 600))
        setShowLogin(!showLogin)
    }

    if ((!data && member) || (member?.['has-username-password-identifier'])) {
        if (member?.['has-username-password-identifier'])
            return <Loading />
        return null;
    }


    if (showReviews)
        return <Wrapper
            onSubmit={() => {
                firePostMemberEvent('create_account')
                setShowReviews(false)
            }}
            percentComplete={0}
            bg="aliceBlue"
        >
            <Flex flexDirection="column" >
                <Image src={GiftBox} maxWidth={200} m="auto" />
                <Text
                    textAlign="center"
                    color="codGrey"
                    fontFamily="Bitter"
                    fontSize="30px"
                    fontStyle="normal"
                    fontWeight={600}
                    lineHeight="120%"
                    letterSpacing="-0.18px"
                    mt='20px'
                >
                    Create a Lifetime of Smiles
                </Text >
                <Text
                    color="#34495E"
                    fontSize={16}
                    fontFamily="Poppins"
                    lineHeight="150%"
                    fontWeight={400}
                    letterSpacing="-0.32px"
                    textAlign="center"
                    my={2}
                >
                    With Baby’s First Year, you don’t just preserve memories; you bring them to life!
                </Text>
                <Reviews reviews={userReviews} />
            </Flex>
        </Wrapper>

    return (
        <Formik
            initialValues={setInitialValues()}
            enableReinitialize
            validationSchema={setShowValidationSchema()}
            onSubmit={onSubmit}
        >
            {({ isSubmitting, handleSubmit, setFieldValue }) => (
                <Form>
                    <Wrapper
                        showLoginButton={pathname.includes('child_journal_share')}
                        showLogin={showLogin}
                        onSubmit={handleSubmit}
                        toggleLogin={toggleLogin}
                        onStepUp={onStepUp}
                        onStepDown={pathname !== '/' && onStepDown}
                        isSubmitting={isSubmitting}
                        heading={showLogin ? 'Welcome Back to Your Baby’s Journey' : 'Your Baby’s Story Begins Here'}
                        subHeading={showLogin ? 'Log in to continue creating a keepsake full of love and memories.' : 'Create an account to begin capturing cherished moments and milestones'}
                        // mainImage={isFromMobile ? mobilePurchaseGiftBFY : (showLogin ? SignInBg : SignUpBg)}
                        percentComplete={0}
                        bg="aliceBlue"
                        nextButtonText={nextButtonText()}
                        buttonSx={{ ml: 'auto', width: 'max-content' }}
                        backText={showLogin ? 'Welcome Back!' : ''}
                    >
                        <Box width="100%" maxWidth="600px" mx="auto">
                            {(redeemCode || status?.message) && (
                                <Banner
                                    bg={(status.type === 'success' || redeemCode) ? 'successBg' : 'pinks.1'}
                                    color={(status.type === 'success' || redeemCode) ? 'success' : 'pinks.5'}
                                    heading={status.message || "Gift card applied successfully"}
                                    text={status.subTitle || "You're all set to preserve and celebrate your little one's firsts"}
                                    p="16px"
                                    size={'small'}
                                    mb={2}
                                />
                            )}
                            <Box >
                                <Flex flexDirection="column" m="auto">
                                    {/* <Text
                                            sx={{
                                                color: "#34495E",
                                                textAlign: "center",
                                                fontFamily: "Poppins",
                                                fontSize: "15px",
                                                fontStyle: "normal",
                                                fontWeight: "400",
                                                lineHeight: "150%",
                                                letterSpacing: "-0.3px",
                                            }}
                                        >
                                            {showLogin ? 'Welcome Back!' : 'Step 1 of 3'}
                                        </Text> */}
                                    {/* {pathname.includes('get-started') && !isFromMobile && <IoIosArrowRoundBack size={30} style={{ cursor: 'pointer' }} onClick={onStepDown} />} */}
                                    <Text
                                        color="codGrey"
                                        textAlign="left"
                                        fontFamily="Bitter"
                                        fontSize={[24, 28]}
                                        lineHeight={["34px", "38px"]}
                                        letterSpacing="-0.6"
                                        mt={2}
                                        mb={1}
                                    >
                                        {title()}
                                    </Text>

                                    {/* <Box m="auto" mb={3} sx={{ display: width < 600 && 'none' }}>
                                            <LoginSection onLoginPress={toggleLogin} showLogin={showLogin} />
                                        </Box> */}
                                    {(!redeemCode) && (showGiftcard ? <Flex sx={{ position: 'relative' }}>
                                        {status?.type &&
                                            <Box sx={{
                                                position: 'absolute',
                                                marginTop: '38px',
                                                marginLeft: '10px',
                                            }}>
                                                {status?.type === 'error' ?
                                                    <Box as={IoMdClose} color="#471E08" size={24} bg="#FFDCC8" sx={{ borderRadius: '50%', p: '4px' }} /> :
                                                    <Box as={IoMdCheckmark} color="#112A09" size={24} bg="#C2F1A5" sx={{ borderRadius: '50%', p: '4px' }} />}
                                            </Box>}
                                        <Box as={IoMdClose} onClick={() => {
                                            setFieldValue('gift-certificate', '')
                                            setStatus({ type: '', message: '' })
                                            setShowGiftcard(!showGiftcard)
                                        }} color="#fff" size={24} bg="#000" sx={{
                                            cursor: 'pointer',
                                            borderRadius: '50%', p: '4px', position: 'absolute',
                                            right: 0
                                        }} />
                                        <FieldText
                                            name="gift-certificate"
                                            placeholder="Enter gift certificate"
                                            width="100%"
                                            label={label('Gift Certificate')}
                                            onBlur={(e) => !!e.target.value && getCouponDetails(e.target.value)}
                                            mt={0}
                                            pl={status?.type && "40px"}
                                        />
                                    </Flex> :
                                        <Flex maxWidth="max-content" mr="auto" justifyContent="center" alignItems="center" mb={2} onClick={() => push(`/babys-first-year/get-started?step=0`)}
                                            sx={{ cursor: 'pointer' }}>
                                            <Box as={IoMdGift} color="#43115A" size={30} mr={1} bg="#F5EBFC" sx={{ borderRadius: '50%', p: '6px' }} />
                                            <Text sx={{ textDecorationLine: 'underline' }}>Redeem a gift certificate</Text>
                                        </Flex>)}
                                    {!showLogin && (
                                        <Flex>
                                            <FieldText
                                                name="first_name"
                                                placeholder="First name"
                                                width="50%"
                                                label={label('Your first name', true)}
                                                mr={[1, 3]}
                                                mt={0}
                                            />
                                            <FieldText
                                                name="last_name"
                                                placeholder="Last name"
                                                width="50%"
                                                label={label('Your last name', true)}
                                                mt={0}
                                            />
                                        </Flex>
                                    )}
                                    <FieldText
                                        name="email"
                                        label={label('Your email', true)}
                                        width="100%"
                                        placeholder="Enter your email address" />
                                    <FieldText
                                        name="password"
                                        type="password"
                                        label={label(showLogin ? 'Your password' : 'Create a password', true)}
                                        placeholder="Enter your password"
                                        width="100%"
                                    />
                                </Flex>
                                <Text>
                                    {/* Own route (see auth/forgot-password.js) so refreshing keeps the
                                            user on the reset page and the link is shareable. */}
                                    {showLogin && <RouterLink to="/password/forgot">
                                        Forgot Your Password?
                                    </RouterLink>}
                                </Text>
                            </Box>

                            <Flex mx="auto" my={5} sx={{
                                background: '#F0F6FE',
                                width: "480px",
                                padding: "29px",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "10px"
                            }}>
                                <Text sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    lineHeight: '150%',
                                    letterSpacing: '-0.26px',
                                    color: '#34495E'
                                }}>
                                    Made an order and don’t have a password?
                                </Text>
                                <Text sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: '150%',
                                    letterSpacing: '-0.32px',
                                    color: '#34495E'
                                }}>
                                    Our system has changed - click "Forgot your password?" to set one up. Once you're logged in, you can add your purchase to a gift certificate.
                                </Text>
                            </Flex>
                        </Box>
                    </Wrapper>
                </Form>
            )}
        </Formik>

    );
};

export default LoginSignUp;
